import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import reportWebVitals from './reportWebVitals';
import {
  BrowserRouter
} from 'react-router'
import App from './App';
import { track } from './firebase/telemetry';
import { installGlobalErrorHandlers } from './firebase/errorReporting';

// Catch errors thrown outside React's render phase (map callbacks, async WFS
// code, unhandled rejections). Installed before render so a crash during the
// first paint is still reported.
installGlobalErrorHandlers();




/*
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithNavigate>
        <App />
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  </React.StrictMode>
);
*/

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>

);

// Web Vitals -> GA4. Called with no callback these were measured and thrown
// away. CLS is a unitless ratio, the rest are milliseconds; GA4 wants integers,
// so CLS is scaled by 1000 (the standard web-vitals reporting convention).
reportWebVitals(({ name, delta, value, id }) => {
  track('web_vitals', {
    metric_name: name,
    metric_value: Math.round(name === 'CLS' ? value * 1000 : value),
    metric_delta: Math.round(name === 'CLS' ? delta * 1000 : delta),
    metric_id: id,
  });
});
